import React from "react";
import { Globe } from "react-feather";
import SessionControl from "../../components/SessionControl/sessioncontrol";
import CheckRestauSelected from "../../components/SessionControl/checkrestauselected";
import { all_routes } from "../../../Router/all_routes";

const Marketplace = () => {
    return (
        <div className="page-wrapper">
            <SessionControl storageKey="user" propsup="email" redirectTo={all_routes.signin} />
            <CheckRestauSelected storageKey="user" redirectTo={all_routes.Restaurants} />
            
            <div className="marketplace-page-inner" style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: 'calc(100vh - 80px)', // Adjust based on header/sidebar
                textAlign: 'center',
                color: '#64748b'
            }}>
                <Globe size={64} style={{ marginBottom: '24px', opacity: 0.5, color: '#3b82f6' }} />
                <h1 style={{ fontSize: '2rem', fontWeight: 700, color: '#1e293b', marginBottom: '8px' }}>Marketplace</h1>
                <p style={{ fontSize: '1.125rem', maxWidth: '400px' }}>
                    Notre Marketplace est en cours de construction. Revenez bientôt !
                </p>
                <div style={{
                    marginTop: '24px',
                    padding: '8px 16px',
                    background: '#eff6ff',
                    color: '#3b82f6',
                    borderRadius: '20px',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                }}>
                    Coming Soon
                </div>
            </div>
        </div>
    );
};

export default Marketplace;
